// extracted by mini-css-extract-plugin
export var aiStarIcon = "_lc-2";
export var container = "_lc-4";
export var dismissButton = "_lc-3";
export var hasPaddingBottom = "_lc-6";
export var last = "_lc-e";
export var scrollbarThumb = "_lc-c";
export var scrollbarTrack = "_lc-b";
export var selected = "_lc-9";
export var spin = "_lc-1";
export var spinning = "_lc-0";
export var suggestionItem = "_lc-d";
export var suggestionsPanel = "_lc-5";
export var tonePill = "_lc-8";
export var tonesContainer = "_lc-7";
export var unselected = "_lc-a";